import { RefreshCw, TriangleAlert } from 'lucide-react';
import { Component, type ErrorInfo, type ReactNode } from 'react';

/**
 * Última linha de defesa. Um erro de renderização não pode virar tela branca:
 * mesmo aqui a mensagem cita o que falhou e oferece uma saída.
 */
export class ErrorBoundary extends Component<{ children: ReactNode }, { erro: Error | null }> {
  state = { erro: null as Error | null };

  static getDerivedStateFromError(erro: Error) {
    return { erro };
  }

  componentDidCatch(erro: Error, info: ErrorInfo) {
    console.error('[PAN] Erro não tratado na renderização:', erro, info.componentStack);
  }

  render() {
    const { erro } = this.state;
    if (!erro) return this.props.children;

    return (
      <div role="alert" className="flex min-h-full flex-col items-center justify-center gap-3 bg-bg-page p-6 text-center">
        <TriangleAlert className="size-7 text-danger" aria-hidden="true" />
        <h1 className="text-page-title text-danger">O PAN não conseguiu desenhar esta tela</h1>
        <p className="max-w-xl text-body text-on-surface">{erro.message}</p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="mt-2 inline-flex min-h-11 items-center gap-2 rounded-button border border-border-strong bg-bg-surface px-4 text-body font-bold text-on-surface"
        >
          <RefreshCw className="size-4" aria-hidden="true" />
          Recarregar a aplicação
        </button>
      </div>
    );
  }
}
